<template>
  <div>
    <topTab ref="topTab" :tabData="tabData" @tabChange="changePages">
      <orderAllDataState v-if="activeTab === '1'"></orderAllDataState>
      <orderNumStatistic v-if="activeTab === '2'"></orderNumStatistic>
      <orderMontyStatistic v-if="activeTab === '3'"></orderMontyStatistic>
    </topTab>
  </div>
</template>
<script>
import orderAllDataState from "./orderAllDataState.vue";
import orderNumStatistic from "./orderNumStatistic.vue";
import orderMontyStatistic from "./orderMontyStatistic.vue";
export default {
  data() {
    return {
      activeTab: "1",
      tabData: [
        {
          key: "1",
          value: "订单数量统计",
        },
        {
          key: "2",
          value: "门店订单统计",
        },
        {
          key: "3",
          value: "订单金额统计",
        },
      ],
    };
  },
  // 注册组件
  components: {
    orderAllDataState,
    orderNumStatistic,
    orderMontyStatistic,
  },
  created() {

  },
  computed: {},
  methods: {
    changePages(tab) {
      this.activeTab = tab;
    },
  },
};
</script>

<style scoped lang="scss"></style>